<div class="container-fluid">
    <div class="row">

        <div class="card shadow-sm p-0">
            <div class="card-header">
                <h3 class="card-title">{{ requestCategoryId ? 'Update Request Category' : 'Edit Request Category' }} </h3>
            </div>
            <div class="card-body">
                <request-categories-form [requestCategory]="requestCategory" />
            </div>
        </div>
    </div>

</div>